var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHalfSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 45,
    viewBox: "0 0 37 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_55",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 45
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 45,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0566 16.5303C19.3243 14.796 17.231 13.9282 14.776 13.9282C12.3201 13.9282 10.2268 14.796 8.49415 16.5303C6.76153 18.264 5.89638 20.3489 5.89638 22.783C5.89638 25.2512 6.76153 27.3608 8.49415 29.1117C10.2268 30.8629 12.3201 31.7377 14.776 31.7377C17.231 31.7377 19.3243 30.8629 21.0566 29.1117C22.7892 27.3608 23.6554 25.2512 23.6554 22.783C23.6554 20.3489 22.7892 18.264 21.0566 16.5303ZM24.3598 32.1402C21.7102 34.7566 18.5063 36.0645 14.7505 36.0645C11.0278 36.0645 7.84122 34.7566 5.19164 32.1402C2.54172 29.5242 1.21727 26.3721 1.21727 22.682C1.21727 19.0597 2.54172 15.9744 5.19164 13.4251C7.84122 10.8768 11.0278 9.6015 14.7505 9.6015C18.5063 9.6015 21.7102 10.8768 24.3598 13.4251C27.009 15.9744 28.3345 19.0597 28.3345 22.682C28.3345 26.3721 27.009 29.5242 24.3598 32.1402V32.1402ZM-12.9197 13.9282C-15.3016 13.9282 -17.2717 14.7708 -18.831 16.4546C-20.3906 18.1394 -21.1704 20.2483 -21.1704 22.783C-21.1704 25.218 -20.3743 27.319 -18.7808 29.0865C-17.1883 30.8543 -15.2843 31.7377 -13.0708 31.7377C-11.561 31.7377 -10.1526 31.3236 -8.84471 30.4936C-7.53652 29.664 -6.5475 28.5362 -5.8763 27.1094H-0.644221C-1.58343 29.86 -3.15963 32.0396 -5.37315 33.65C-7.587 35.2597 -10.1363 36.0645 -13.0203 36.0645C-16.6427 36.0645 -19.6861 34.7901 -22.1514 32.2409C-24.6167 29.6922 -25.8491 26.5395 -25.8491 22.783C-25.8491 19.0936 -24.6087 15.9744 -22.1265 13.4251C-19.645 10.8768 -16.5759 9.6015 -12.9197 9.6015C-10.0357 9.6015 -7.42825 10.4657 -5.09683 12.1926C-2.76541 13.9203 -1.28154 16.075 -0.644221 18.6572H-5.8763C-7.62055 15.5054 -9.96857 13.9282 -12.9197 13.9282ZM-35.2818 15.9408C-36.8756 14.4649 -38.7284 13.7273 -40.8413 13.7273C-43.3564 13.7273 -45.4195 14.6326 -47.0292 16.4437C-48.0355 17.5845 -48.6898 19.1942 -48.9913 21.2735H-32.7414C-32.8417 19.1942 -33.689 17.4167 -35.2818 15.9408V15.9408ZM-28.2131 24.8956H-48.9913C-48.4882 26.96 -47.4905 28.6172 -45.998 29.8653C-44.5058 31.1133 -42.7363 31.7377 -40.6902 31.7377C-37.6049 31.7377 -35.2406 30.3292 -33.5966 27.5116H-28.8674C-29.8066 30.128 -31.3665 32.208 -33.5465 33.7503C-35.7271 35.2933 -38.1744 36.0645 -40.8915 36.0645C-44.4132 36.0645 -47.4317 34.7652 -49.9475 32.1655C-52.4625 29.567 -53.7202 26.4389 -53.7202 22.783C-53.7202 19.0936 -52.4625 15.9408 -49.9475 13.3245C-47.4317 10.7084 -44.3803 9.40057 -40.7908 9.40057C-37.303 9.40057 -34.3093 10.6832 -31.8105 13.2491C-29.3121 15.815 -28.0623 18.8926 -28.0623 22.4808C-28.0623 23.0178 -28.1128 23.8228 -28.2131 24.8956",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.944 28.9219L17.8433 21.8263H15.4783L16.1538 16.9267L12.0991 23.6845H14.2953L12.944 28.9219Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1123 1.89103H15.6463V7.12842H13.1123V1.89103Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5136 21.4886H35.751V24.0229H30.5136V21.4886Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68112 5.74692L4.87571 4.47991L7.49441 9.01522L5.29982 10.2822L2.68112 5.74692Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2881 5.34376L24.1321 4.09071L21.5595 8.57653L23.7156 9.82959L26.2881 5.34376Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3697 13.3309L32.1289 11.1672L27.6577 13.766L28.8985 15.9297L33.3697 13.3309Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0854 38.3832H15.6194V43.6206H13.0854V38.3832Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63864 39.7642L4.83622 41.0312L7.45791 36.4959L5.26066 35.2289L2.63864 39.7642Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2774 40.1678L24.1183 41.4209L21.5424 36.9354L23.7012 35.682L26.2774 40.1678Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3654 32.1807L32.1233 34.3447L27.6465 31.7456L28.8889 29.5819L33.3654 32.1807Z",
    fill: "#86BE88"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfSun);
export default __webpack_public_path__ + "static/media/half-sun.8f62e98c07b8286d11fa32bf351e6a3c.svg";
export { ForwardRef as ReactComponent };